var map = {
	"./activtrades.png": 2949,
	"./admiral_markets.png": 7513,
	"./ads_securities.png": 1462,
	"./ava_trade.png": 2228,
	"./axi.png": 8225,
	"./axiory.png": 4225,
	"./bd_swiss.png": 5919,
	"./black_bull_markets.png": 660,
	"./capital_index.png": 7396,
	"./capitalcom.png": 3746,
	"./city_index.png": 4965,
	"./cmc_markets.png": 4204,
	"./darwinex.png": 1507,
	"./dukascopy.png": 1266,
	"./eightcap.png": 8314,
	"./exness.png": 7635,
	"./fbs.png": 5829,
	"./forex_time.png": 1899,
	"./forexcom.png": 5496,
	"./fp_markets.png": 389,
	"./ftmo.png": 9011,
	"./fx_open.png": 2628,
	"./fx_pro.png": 5047,
	"./fxcm.png": 1235,
	"./global_prime.png": 6316,
	"./go_markets.png": 8153,
	"./hf_markets.png": 297,
	"./ic_markets.png": 6180,
	"./ig.png": 2245,
	"./insta_forex.png": 3503,
	"./marketscom.png": 6579,
	"./meta_quotes.png": 7724,
	"./oanda.png": 5498,
	"./octa_fx.png": 1365,
	"./pepperstone.png": 4502,
	"./roboforex.png": 2067,
	"./robomarkets.png": 886,
	"./swissquote.png": 6102,
	"./thinkmarkets.png": 9814,
	"./tickmill.png": 9668,
	"./xtb.png": 5511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5427;